import React from "react";
import "./footer.css";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="footer" role="contentinfo">
      <div className="footer-container">
        
        <div className="footer-center">
          &copy; 2026 Cerebral Palsy Alliance
        </div>

        <div className="footer-right" role="list">
          
          <Link to="" className="footer-link" role="listitem">
            Privacy
          </Link>
          <Link to="" className="footer-link" role="listitem">
            Terms of Use
          </Link>
          <Link to="/FeedbackPage" className="footer-link" role="listitem">
            Feedback
          </Link>
        </div>

      </div>
    </footer>
  );
}
